<div mat-dialog-title>
    <span class="text">{{ title }}</span>
    <fui-button
        (clickEvent)="close.next({ save: false })"
        [title]="appService.language_dictionary.system_close"
        [iconSize]="16"
        type="button-icon"
        icon="close"
        height="slim"
        color="flat"
        borderRadius="circle"
    >
    </fui-button>
</div>
<ng-content select="[dialogHeader]"></ng-content>
<mat-dialog-content>
    <ng-content select="[dialogContent]"></ng-content>
</mat-dialog-content>
<mat-dialog-actions #content [class.!hidden]="content?.childNodes?.length === 0">
    <ng-content select="[dialogActions]"></ng-content>
</mat-dialog-actions>
